export function setNewDesignSlide(state, payload) {
  const protocolSection = updateDesignSection(state.protocolSection, payload);
  return {
    ...state,
    protocolSection,
  };
}

function updateDesignSection(protocolSection, payload) {
  return {
    ...protocolSection,
    currentSlide: payload.currentSlideType,
  };
}
